// Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BurgerMenu from './BurgerMenu';
import SideBar from './SideBar';
import './Header.css';
import logo from './assets/logo.png';

function Header() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <>
      <header className="header-container">
        <div className="header-wrapper">

          {/* Left Section: Logo + Firm Name */}
          <div className="header-left">
            <Link to="/" className="logo-link">
              <img src={logo} alt="Edgar Lopez Law Firm Logo" className="header-logo" />
            </Link>
          </div>

          {/* Center Section: Desktop Navigation */}
          <nav className="desktop-nav">
            <ul>
              <li>
                <Link to="/"><span>Home</span></Link>
              </li>
              <li>
                <Link to="/about"><span>Personal Injury</span></Link>
              </li>
              <li>
                <Link to="/flight-tracker"><span>Case Results</span></Link>
              </li>
              <li>
                <Link to="/about"><span>About the Attorney</span></Link>
              </li>
              <li>
                <Link to="/contactus"><span>Contact</span></Link>
              </li>
            </ul>
          </nav>

          {/* Right Section: Phone + CTA + Burger */}
          <div className="header-right">
            <div className="header-contact">
              <Link to="/quote" className="header-cta">
                Free Consultation
              </Link>
            </div>

            <div className="burger-menu-container">
              <BurgerMenu isOpen={sidebarOpen} onClick={toggleSidebar} />
            </div>
          </div>

        </div>
      </header>

      <SideBar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
    </>
  );
}

export default Header;